export enum ReportsLeadsRoutes {
    leadsIndustry = "industry-reports",
    leadsOwner = "owner-reports",
    leadsSource = "source-reports",
    leadsStage = "stage-reports",
    leadsCreatedate = "created-reports",
    leadsType = "type-reports",
    leadsConverted = "converted-leads",
    leadsActivity = "activity-reports",
    leadsNoActivity = "no-activity-reports",
    leadsConversion = "conversion-reports",
    leadsConversionSummary = "conversion-summary",
    leadsAging = "aging-reports"
}


export enum ReportsLeadsTypes {
    leadsIndustry = "leadsIndustry",
    leadsOwner = "leadsOwner",
    leadsSource = "leadsSource",
    leadsStage = "leadsStage",
    leadsCreatedate = "leadsCreatedate",
    leadsType = "leadsType",
    leadsConverted = "leadsConverted",
    leadsActivity = "leadsActivity",
    leadsNoActivity = "leadsNoActivity",
    leadsConversion = "leadsConversion",
    leadsConversionSummary = "leadsConversionSummary",
    leadsAging = "leadsAging"
}

export enum ReportsLeadsPermissions {
    leadsIndustry = "Lead By Industry",
    leadsOwner = "Closed Leads By Owner",
    leadsSource = "Lead By Source",
    leadsStage = "Lead By Stage",
    leadsCreatedate = "Lead By Create Date",
    leadsType = "Lead By Type",
    leadsConverted = "Lead By Converted",
    leadsActivity = "Lead By Activity",
    leadsNoActivity = "Lead By No Activity",
    leadsConversion = "Lead By Conversion",
    leadsConversionSummary = "Lead By Conversion Summary",
    leadsAging = "Lead By Aging"
}